import { useContext, useCallback, useMemo } from 'react';
import { filterTypes } from '../../config';
import { ConfigContext } from '../..';
import { RetailerIdContext } from '../../App';

const Pill = ({ filter, filterType, brands, handleChange }) => {
    const { tagSlugs } = useContext(ConfigContext);
    const retailerId = useContext(RetailerIdContext);

    const displayText = useMemo(() => {
        if (filterType === filterTypes.brands && brands) {
            const brand = brands.find((b) => b.id === filter);
            if (brand) {
                return brand.name;
            }
        }

        if (
            filterType === filterTypes.tags &&
            tagSlugs &&
            tagSlugs?.hasOwnProperty(retailerId)
        ) {
            return tagSlugs[retailerId]?.hasOwnProperty(filter)
                ? tagSlugs[retailerId][filter]
                : filter;
        }

        return filter;
    }, [filter, filterType, brands, tagSlugs, retailerId]);

    const onClickHandler = useCallback((e) => {
        handleChange(e.currentTarget, filterType);
    }, [handleChange, filterType]);

    return (
        <button
            className='headless-filter-pill'
            value={filter}
            onClick={onClickHandler}
        >
            <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 384 512'>
                <path d='M326.6 166.6L349.3 144 304 98.7l-22.6 22.6L192 210.7l-89.4-89.4L80 98.7 34.7 144l22.6 22.6L146.7 256 57.4 345.4 34.7 368 80 413.3l22.6-22.6L192 301.3l89.4 89.4L304 413.3 349.3 368l-22.6-22.6L237.3 256l89.4-89.4z' />
            </svg>
            <span>{displayText}</span>
        </button>
    );
};

export default Pill;
